import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Sidebar } from './components/layout/sidebar/sidebar';
import { Header } from './components/layout/header/header';
import { Alert } from './components/shared/alert/alert';
import { Auth } from './services/auth';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Sidebar, Header, Alert],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnDestroy {
  private auth = inject(Auth);
  private router = inject(Router);
  private destroy$ = new Subject<void>();
  isAuthenticated = this.auth.isAuthenticated;

  constructor() {
    // Note: Route handling is now done in Header component
    // This subscription was redundant and removed to prevent memory leaks
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
